<template>
  <div class="container">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'BaseContainer'
}
</script>

<style lang="postcss">
.container {
  @apply px-6 mx-auto;
}
@screen xl {
  .container {
    @apply max-w-screen-xl;
  }
}
</style>
